import { CategorieCard } from './../../../../shared/components/cards/interfaces/categorie-card';
import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { CategorieCardComponent } from '../../../../shared/components/cards/categorie-card/categorie-card.component';
import { ContactCardComponent } from '../../../../ppa/shared/components/cards/contact-card/contact-card.component';
import { ModalPopupComponent } from '../../../../ppa/shared/components/modal-popup/modal-popup.component';
import { PublicConsultationService } from '../../../../shared/services/public-consultation.service';

@Component({
  selector: 'app-orcamentary-planning',
  imports: [
    RouterOutlet,
    CategorieCardComponent,
    ContactCardComponent,
    ModalPopupComponent,
  ],
  templateUrl: './orcamentary-planning.component.html',
  styleUrl: './orcamentary-planning.component.scss',
})
export class OrcamentaryPlanningComponent implements OnInit {
  cards: CategorieCard[] = [
    {
      titulo: 'PPA',
      subtitulo: 'Plano Plurianual',
      periodo: '2026-2029 ',
      iconeNome: 'icone-ppa.svg',
      tipoCard: 'ppa',
      botaoHabilitado: false,
      objetivos: [
        'Planejamento estratégico de 4 anos.',
        'Define metas e objetivos da prefeitura.',
        'Orienta investimentos e programas de longo prazo.',
      ],
    },
    {
      titulo: 'LDO',
      subtitulo: 'Lei de Diretrizes Orçamentárias',
      periodo: '2026',
      iconeNome: 'icone-ldo.svg',
      tipoCard: 'ldo',
      botaoHabilitado: false,
      objetivos: [
        'Define prioridades e metas para o próximo ano.',
        'Guia a elaboração do orçamento anual (LOA).',
        'Garante equilíbrio entre receitas e despesas.',
      ],
    },
    {
      titulo: 'LOA',
      subtitulo: 'Lei Orçamentária Anual ',
      periodo: '2026',
      iconeNome: 'icone-loa.svg',
      tipoCard: 'loa',
      botaoHabilitado: false,
      objetivos: [
        'Orçamento detalhado para 1 ano.',
        'Estima receitas e fixa despesas.',
        'Regula como o dinheiro público será gasto.',
      ],
    },
  ];
  isModalOpen = false;

  constructor(private readonly consultationApi: PublicConsultationService) {}

  ngOnInit(): void {
    this.carregarDisponibilidadeLoa();
  }

  private carregarDisponibilidadeLoa(): void {
    this.consultationApi.listarConsultasAbertas().subscribe({
      next: (consultas) => {
        const loaAberta = consultas.some(
          (consulta) => consulta.instrumento === 'LOA' && consulta.aberta,
        );
        this.cards = this.cards.map((card) =>
          card.tipoCard === 'loa'
            ? { ...card, botaoHabilitado: loaAberta }
            : card,
        );
        this.isModalOpen = loaAberta;
      },
      error: () => {
        this.cards = this.cards.map((card) =>
          card.tipoCard === 'loa'
            ? { ...card, botaoHabilitado: false }
            : card,
        );
        this.isModalOpen = false;
      },
    });
  }
}
